import { useLenis } from "@/hooks/useLenis";
import { PlayerProvider } from "@/context/PlayerContext";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Bio } from "@/components/site/Bio";
import { Releases } from "@/components/site/Releases";
import { Newsletter } from "@/components/site/Newsletter";
import { Footer } from "@/components/site/Footer";
import { PlayerBar } from "@/components/site/PlayerBar";

export default function Home() {
  useLenis();
  return (
    <PlayerProvider>
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Bio />
        <Releases />
        <Newsletter />
      </main>
      <Footer />
      <PlayerBar />
    </PlayerProvider>
  );
}
